import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'

import errors from '../../lib/errors.js'
import ReferenceValueCard from './ReferenceValueCard'
import ReferenceValueNotFound from './ReferenceValueNotFound'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'
const ReferenceValueStore = Resource('reference-values')


class ShowReferenceValuePage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      referenceValue: {},
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    ReferenceValueStore.find(this.props.match.params.id)
    .then((result) => this.setState({referenceValue: result.data, loading: false}))
    .catch((error) => this.setState({referenceValue: {}, error: errors.unpack(error), loading: false}))
  }

  _redirectTo = (url) => {
    this.setState({redirect: url})
  }

  render() {
    const {
      loading,
      redirect,
      referenceValue
    } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect}/>
    if (isEmpty(referenceValue)) return (<ReferenceValueNotFound/>)

    return (
      <section>
        <header>
          <PageTitle>
            Reference value
          </PageTitle>
        </header>
        <ReferenceValueCard
          referenceValue={referenceValue}
          editCallback={() => this._redirectTo(`/reference-values/${referenceValue.id}/edit`)}
        />
        <br/>
        <BackButton/>
      </section>
    )
  }
}

export default ShowReferenceValuePage



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/ShowReferenceValuePage.jsx